module.exports = __webpack_public_path__ + "static/img_2187_optimized-555470ddd2146d3ca9bd8698074ef0f5.jpg";